/**
 * Shared illustrated "Back to Map" HUD control.
 * The PNG already contains frame, map, pin, parchment, and label text.
 */

export const BACK_TO_MAP_SRC = `${import.meta.env.BASE_URL}art/ui/back-to-map.png`;

export const BACK_TO_MAP_UTILITY_ID = 'to-places-map';

export function isBackToMapUtility(utility: {
  id: string;
  label: string;
}): boolean {
  return (
    utility.id === BACK_TO_MAP_UTILITY_ID ||
    utility.label.trim().toLowerCase() === 'back to map'
  );
}

/**
 * Image-as-button — no chrome, text, or icons beyond the artwork.
 * Click handler is supplied by the host (navigation unchanged).
 */
export function createBackToMapButton(options: {
  title?: string;
  onActivate: () => void;
}): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'wp-back-to-map';
  button.setAttribute('aria-label', 'Back to Map');
  if (options.title) button.title = options.title;

  const img = document.createElement('img');
  img.src = BACK_TO_MAP_SRC;
  img.alt = '';
  img.decoding = 'async';
  img.draggable = false;
  img.setAttribute('aria-hidden', 'true');
  button.append(img);

  button.addEventListener('click', (event) => {
    event.preventDefault();
    options.onActivate();
  });

  return button;
}
